import React, { useCallback, useEffect, useState } from 'react'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'

import { Button } from 'components/UI'
import UploadVideo from 'components/Upload/Video'
import UploadImage from 'components/Upload/Image'
import Thumbnails from 'components/Upload/Thumbnails'
import Criteria from 'components/Upload/Criteria'
import Preview from 'components/Upload/Preview'

import { CRITERIA, MAX_UPLOADED_IMAGES } from 'constants/upload'

const WithUploadBtn = React.forwardRef(({ value: items, onChange, type }, ref) => {
  const [open, setOpen] = useState(false)
  const [isUploaded, setIsUploaded] = useState(!!items.length)

  const handleClose = () => {
    setOpen(false)
  }

  const onOpen = () => {
    setOpen(true)
  }

  const removeImageThumb = useCallback(
    (index) => {
      const _items = [...items]
      _items.splice(index, 1)
      onChange(_items)
    },
    [items]
  )

  const upload = () => {
    setIsUploaded(true)
    handleClose()
  }

  useEffect(() => {
    if (!isUploaded && items.length) {
      setIsUploaded(true)
    }
  }, [items])

  return (
    <div>
      {isUploaded && items.length ? (
        type === 'video' ? (
          <Preview items={items} onChange={onChange} type={type} />
        ) : (
          <>
            <Preview items={items} onChange={onChange} type={type} />
            <Button
              disabled={items.length === MAX_UPLOADED_IMAGES}
              className={`${items.length === MAX_UPLOADED_IMAGES ? 'bg-[#f3f3f3] cursor-not-allowed' : 'bg-white'} !text-[#F79009] w-full rounded-2 border !border-[#ffca84] mt-3`}
              type="button"
              onClick={onOpen}
            >
              + Upload {type === 'video' ? 'Video' : 'Image'}
            </Button>
          </>
        )
      ) : (
        <Button
          className="bg-white !text-[#F79009] w-full rounded-2 border !border-[#ffca84]"
          type="button"
          onClick={onOpen}
        >
          + Upload {type === 'video' ? 'Video' : 'Image'}
        </Button>
      )}

      <Dialog
        open={open}
        onClose={handleClose}
        scroll="body"
        fullWidth
        maxWidth="sm"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogContent
          sx={{
            padding: '20px 45px',
            background: '#FEEBDD',
          }}
        >
          {type === 'video' ? (
            <>
              <UploadVideo isUploaded={isUploaded} />
              <Criteria data={CRITERIA.video} title="Video should have:" />
            </>
          ) : (
            <>
              <UploadImage isUploaded={isUploaded} />
              <Criteria data={CRITERIA.images} title="Photo should have:" />
              <Thumbnails images={items} remove={removeImageThumb} />
            </>
          )}
          <div className="flex gap-2 mt-3">
            <Button
              variant="static"
              className="bg-white !text-[#F79009] w-full rounded-2 border !border-[#F79009]"
              onClick={handleClose}
            >
              Back
            </Button>
            <Button
              variant="static"
              disabled={!isUploaded}
              className="w-full rounded-2"
              onClick={upload}
            >
              Save
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  )
})

export default WithUploadBtn
